export const isRectAInRectB = (a: DOMRect, b: DOMRect) =>
    a.left >= b.left && a.top >= b.top && a.bottom <= b.bottom && a.right <= b.right;
